export default __webpack_public_path__ + "static/media/periodico.d0ed51d9.png";